var ProductRecommendationAction;
(function(ProductRecommendationAction) {
    ProductRecommendationAction["AddToCart"] = 'addToCart';
    ProductRecommendationAction["AddQuantity"] = 'addQuantity';
    ProductRecommendationAction["Redirect"] = 'redirect';
})(ProductRecommendationAction || (ProductRecommendationAction = {}));
var BannerRecommendationAction;
(function(BannerRecommendationAction) {
    BannerRecommendationAction["DiscountCode"] = 'discountCode';
    BannerRecommendationAction["Link"] = 'link';
})(BannerRecommendationAction || (BannerRecommendationAction = {}));

export { BannerRecommendationAction, ProductRecommendationAction };
//# sourceMappingURL=types.js.map
